import React from 'react'
import Button from 'components/Base/Button'
import classnames from 'classnames'
import * as styles from './index.module.less'

interface CargoCardProduct {
  dataSource?: {
    dataTitle: string
    imgUrl: string
    dataDsc: string
    btnHref: string
    btnText: string
    dataMsg: string
    imgUrlMb: string
  }[]
  className?: string
}

const CargoCard: React.FC<CargoCardProduct> = ({ dataSource, className }) => {
  return (
    <div className={classnames(styles.ProductCardContainer, className)}>
      <div className="product-content">
        <ul className="product-card">
          {dataSource?.map((item, index) => (
            <li key={item.dataTitle}>
              <div>
                <img src={item.imgUrl} alt="" />
              </div>
              <div className="card-content">
                {item.dataMsg && <div className="card-msg">{item.dataMsg}</div>}
                {item.dataTitle && <div className="card-title">{item.dataTitle}</div>}
                {item.dataDsc && <div className="card-dsc">{item.dataDsc}</div>}
                <a className="card-more" href={item.btnHref} target="_blank">
                  {item.btnText}
                </a>
              </div>
            </li>
          ))}
        </ul>
        <div className="product-swiper-mb">
          <ul className="dry-card">
            {dataSource?.map((item) => (
              <li key={item.dataTitle}>
                <a href={item.btnHref} target="_blank">
                  <div className="dry-type">
                    <img src={item.imgUrlMb} alt={item.dataTitle} />
                    <span>{item.dataTitle}</span>
                    <strong>{item.btnText}</strong>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

export default CargoCard
